import { ScopedAsyncType } from './scoped-type';
import { asyncAction } from './async-action';
import { get } from '../../lib/api';

const AsyncType = ScopedAsyncType('PERMISSIONS');
const REFRESH = AsyncType('REFRESH');

export const actions = {
  refreshPermissions(growerId) {
    return asyncAction(REFRESH, () =>
      get(`/permissions`, {
        params: growerId ? { growerId } : {},
      }),
    );
  },
};

export const selectors = {
  all: (state) => state.permissions || [],
};

export const reducers = {
  permissions: permissionsReducer,
};

function permissionsReducer(state = [], { type, payload } = {}) {
  if (type === 'AUTH/LOGIN_COMPLETE') return [...payload.permissions];
  if (type === REFRESH.complete) return payload;
  return state;
}
